<template>
    <div class="login"></div>
</template>

<script>
export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {},
    created() {
        this.$api.login().then(() => {
            if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect);
            } else {
                this.$router.push('/');
            }
        });
    }
};
</script>
